import { useLoaderData } from 'react-router';
import { OfferType } from '../../common/enums.js';
import { productOfferingsEmptyMessage, productOfferingsEmptyTitle, t } from '../../common/i18n/index.js';
import { ProductOfferingsEmptyPageCoCo } from '../EmptyOrError/ProductOfferingsEmptyPageCoCo.js';
import { Grid } from '../Grid/Grid.js';
import { ProductOfferingsCardCoCo } from './ProductOfferingsCardCoCo.js';
import type { ProductOfferingsResponse } from '../../generated/api/productOfferingsResponse.js';

export interface HorizontalMobileBroadbandProductOfferingsCoCoProps {
  publicPages: boolean;
}

export const HorizontalMobileBroadbandProductOfferingsCoCo = ({
  publicPages,
}: HorizontalMobileBroadbandProductOfferingsCoCoProps) => {
  const productOfferings = (useLoaderData() as ProductOfferingsResponse[]) ?? [];

  if (productOfferings.length === 0) {
    return (
      <Grid colWidthL={publicPages ? 10 : 12}>
        <ProductOfferingsEmptyPageCoCo
          title={t.ZZWO(productOfferingsEmptyTitle)}
          message={t.ZZWM(productOfferingsEmptyMessage)}
        />
      </Grid>
    );
  }

  return (
    <Grid colWidthL={12}>
      <div className="of-subscriptions-main-container">
        {productOfferings.map(sub => (
          <ProductOfferingsCardCoCo
            key={sub.id}
            productOfferings={sub}
            publicPages={publicPages}
            offerType={OfferType.MOBILE_BROADBAND}
          />
        ))}
      </div>
    </Grid>
  );
};
